import { getUsers } from "../services/User/getUsers";
import { AuthUser } from "../types/User/AuthUser";

const USERS_CACHE_KEY = "cachedUsers";

export const checkEmailExists = async (
  email: string,
  currentUserEmail?: string,
): Promise<boolean> => {
  try {
    const cachedUsers = localStorage.getItem(USERS_CACHE_KEY);
    let users;

    if (cachedUsers) {
      users = JSON.parse(cachedUsers);
    } else {
      const result = await getUsers();
      users = result.content;
      localStorage.setItem(USERS_CACHE_KEY, JSON.stringify(users));
    }

    const emailExists = users.some(
      (user: AuthUser) =>
        user.email === email && user.email !== currentUserEmail,
    );
    return emailExists;
  } catch (error) {
    console.log("Error checking if email exists:", error);
    return false;
  }
};

export const clearUsersCache = () => {
  localStorage.removeItem(USERS_CACHE_KEY);
};
